{% block swag_migration_wizard_page_credentials %}
    <div class="swag-migration-wizard-page-credentials">
        {% block swag_migration_wizard_page_credentials_forms %}
            <component
                v-if="credentialsComponent !== '' && componentIsLoaded"
                :is="credentialsComponent"
                :credentials="credentials"
                @on-credentials-changed="$emit('onCredentialsChanged', $event)"
                @on-child-route-ready-changed="$emit('onChildRouteReadyChanged', $event)"
                @on-trigger-primary-click="$emit('onTriggerPrimaryClick')"
            />
        {% endblock %}

        {% block swag_migration_wizard_page_credentials_no_form_found %}
            <template v-else>
                <div class="swag-migration-wizard-page-credentials__empty_state">
                    {% block swag_migration_wizard_page_credentials_no_form_found_content %}
                        <p class="swag-migration-wizard__emptyStateDescription">
                            {{ $tc('swag-migration.wizard.pages.credentials.emptyState') }}
                        </p>
                    {% endblock %}
                </div>
            </template>
        {% endblock %}
    </div>
{% endblock %}
